<template>
    <b-button
        variant="danger"
        @click.stop="confirmarDescomprometerSelecionados()"
        :disabled="comprometimentosSelecionados.length == 0"
    >
        <span
            ><i class="fa fa-times-circle-o mr-2"></i> Descomprometer
            selecionados</span
        >
    </b-button>
</template>

<script>
import ComprometimentosServicos from './ComprometimentosServicos'

export default {
    components: {},

    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        comprometimentosSelecionados: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDescomprometerSelecionados() {
            const quantidade = this.comprometimentosSelecionados.length
            const mensagem = `Confirma a realização do descomprometimento de ${quantidade}
                              comprometimento(s) selecionado(s) no RM?`
            this.$swal({
                title: 'Descomprometimento',
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.descomprometerSelecionados()
                }
            })
        },

        descomprometerSelecionados() {
            this.$store.dispatch('addRequest')
            let comprometimentosDto = {
                idsComprometimentos: this.comprometimentosSelecionados
            }
            ComprometimentosServicos.descomprometerSelecionados(
                this.contrato.idContrato,
                comprometimentosDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Descomprometimentos realizados com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarComprometimentos')
                    } else {
                        this.$emit('atualizarComprometimentos')
                        this.$emit('atualizarErros', response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
